export default __webpack_public_path__ + "static/fall9-f0abcd9b22f18adcb4edcb0095ebe2ad.webp";